import { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

const SalesAnalytics = ({ user }) => {
  const [orders, setOrders] = useState([]);
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });

  useEffect(() => {
    if (user) {
      fetchOrders();
    }
  }, [user]);

  const fetchOrders = async () => {
    try {
      const ordersSnapshot = await getDocs(collection(db, 'orders'));
      const orderList = [];
      for (const orderDoc of ordersSnapshot.docs) {
        const itemsSnapshot = await getDocs(collection(db, 'orders', orderDoc.id, 'items'));
        const items = itemsSnapshot.docs.map(itemDoc => ({
          id: itemDoc.id,
          ...itemDoc.data()
        }));
        orderList.push({
          id: orderDoc.id,
          ...orderDoc.data(),
          items,
          timestamp: orderDoc.data().timestamp?.toDate()
        });
      }
      setOrders(orderList);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const filteredOrders = orders.filter(order => {
    const orderDate = order.timestamp;
    const startDate = dateRange.startDate ? new Date(dateRange.startDate) : null;
    const endDate = dateRange.endDate ? new Date(dateRange.endDate) : null;
    return (
      (!startDate || orderDate >= startDate) &&
      (!endDate || orderDate <= endDate)
    );
  });

  const calculateMetrics = () => {
    const totalSales = filteredOrders.reduce((sum, order) => sum + (order.total || 0), 0);
    const itemSales = {};
    filteredOrders.forEach(order => {
      if (Array.isArray(order.items)) {
        order.items.forEach(item => {
          const itemName = item.eventID || 'Unknown Item'; // Using eventID as the item name
          itemSales[itemName] = (itemSales[itemName] || 0) + 1; // No quantity field, assuming 1 per item
        });
      }
    });
    const topItems = Object.entries(itemSales)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
    return { totalSales, topItems };
  };

  const { totalSales, topItems } = calculateMetrics();

  return (
    <div>
      <h2>Sales Analytics</h2>
      <div className="filter-section">
        <input
          type="date"
          value={dateRange.startDate}
          onChange={e => setDateRange({ ...dateRange, startDate: e.target.value })}
        />
        <input
          type="date"
          value={dateRange.endDate}
          onChange={e => setDateRange({ ...dateRange, endDate: e.target.value })}
        />
      </div>
      <div className="summary-section">
        <h3>Summary</h3>
        <p>Total Sales: ${totalSales.toFixed(2)}</p>
        <h4>Top 5 Items</h4>
        {topItems.length === 0 ? (
          <p>No items sold in the selected date range.</p>
        ) : (
          <ul>
            {topItems.map(([itemName, quantity]) => (
              <li key={itemName}>{itemName}: {quantity} sold</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SalesAnalytics;